// extracted by mini-css-extract-plugin
module.exports = {"checkBoxIcon":"CustomCheckbox_checkBoxIcon__3gu_5","checkBoxCheckedIcon":"CustomCheckbox_checkBoxCheckedIcon__1YnHe"};